"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Shopify.theme.jsAjaxCart = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart($section);
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {
      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');
      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.showDrawer();
        return false;
      });
    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      var $addToCartForm = $(this).closest('form');
      Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
      return false;
    });
    window.addEventListener('load', function () {
      Shopify.theme.jsAjaxCart.addEventToButtons();
    })
    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      var lineID = $(this).parents('[data-line-item]').data('line-item');
      Shopify.theme.jsAjaxCart.removeFromCart(lineID);

      if (Shopify.theme.jsCart) {
        Shopify.theme.jsCart.removeFromCart(lineID);
      }

      return false;
    });
    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      Shopify.theme.jsAjaxCart.hideDrawer();
      Shopify.theme.jsAjaxCart.hideMiniCart();
      return false;
    });
  },
  showMiniCartOnHover: function showMiniCartOnHover() {
    var $el = $('[data-ajax-cart-trigger]');
    $el.hover(function () {
      if (Shopify.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function () {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function hideMiniCart() {
    if (this.cart_action != 'mini_cart') return false;
    var $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function toggleMiniCart() {
    var $el = $('.mobile-header [data-ajax-cart-trigger]'); // Removes url to the cart page so user is not redirected

    $el.attr('href', '#');
    $el.off('click').on('click', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      } // Loads content into ajaxCart container for mobile header


      Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile(); // If user clicks outside the element, toggle the mini cart

      $el.toggleClass('show-mini-cart'); // Calculate height of mini cart

      var announcementHeight = 0;
      var mobileHeaderHeight = parseInt($('.mobile-header').height());

      if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky) {
        announcementHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
      }

      $('.mobile-header .theme-ajax-cart').css({
        height: "calc(100vh - ".concat(mobileHeaderHeight + announcementHeight, "px)")
      });
    });
  },
  showDrawer: function showDrawer() {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
    $('html, body').addClass('sidecart-active');
  },
  hideDrawer: function hideDrawer() {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
    $('html, body').removeClass('sidecart-active');
  },
  removeFromCart: function removeFromCart(lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function success(cart) {
        Shopify.theme.jsAjaxCart.updateView();
      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  initializeAjaxCart: function initializeAjaxCart($section) {
    Shopify.theme.asyncView.load('/cart', // template name
    'ajax' // view name (suffix)
    ).done(function (_ref) {
      var html = _ref.html,
          options = _ref.options;
      $('[data-ajax-cart-content]').html(html.content); // Converting the currencies
      var $prevButton = $section.find('.featured-promotions__nav--prev');
      var $nextButton = $section.find('.featured-promotions__nav--next');
      var $promoSlider = $section.find('[data-featured-promotions-slider]');
      var $featuredPromosSlider = $promoSlider.flickity({
        initialIndex: 1,
        contain: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'left',
        on: {
          ready: function ready() {
            // Reset layout to avoid collapsing issues
            setTimeout(function () {
              $featuredPromosSlider.flickity('resize');
            }, 500);
          }
        }
      });
      $prevButton.on('click', function () {
        $featuredPromosSlider.flickity('previous');
      });
      $nextButton.on('click', function () {
        $featuredPromosSlider.flickity('next');
      });
      if (!$('.ajax-cart__empty-cart-message').hasClass('is-hidden')){
        $('.index__cart-products-slider-container').addClass('slider-hidden')
      }
      if (Currency.show_multiple_currencies) {
        Shopify.theme.currencyConverter.convertCurrencies();
      }

      affirm.ui.refresh();
    }).fail(function () {// some error handling
    });
  },
  initializeAjaxCartOnMobile: function initializeAjaxCartOnMobile() {
    this.toggleMiniCart();
    Shopify.theme.asyncView.load('/cart', // template name
    'ajax' // view name (suffix)
    ).done(function (_ref2) {
      var html = _ref2.html,
          options = _ref2.options;
      $('.mobile-header [data-ajax-cart-content]').html(html.content);
    }).fail(function () {// some error handling
    });
  },
  addToCart: function addToCart($addToCartForm) {
    if(window.innerWidth < 769 && $('.swatch').length) {
      var elementTop = $('.swatch').offset().top;
      var elementBottom = elementTop + $('.swatch').outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      if (elementBottom > viewportTop && elementTop < viewportBottom) {
        this.addItemToCart($addToCartForm);
      } else {
        $('html, body').animate({
          scrollTop: $('.swatch').offset().top - 100
        }, 10);
        $('[data-add-to-cart]').attr('style', 'background: #f95172; color: #FFFFFF !important; ');
      }
    } else {
      this.addItemToCart($addToCartForm);
    }
  },
  addItemToCart: function addItemToCart ($addToCartForm) {
    var $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
   // $addToCartBtn.on('click', function(){
   //   $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
   //   $().ready(function(){
   //     $addToCartBtn.removeAttr('disabled').removeClass('disabled');
   //   })
   // });
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $addToCartForm.serialize(),
      beforeSend: function beforeSend() {
        $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
        $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
      },
      success: function success(product) {
        var $el = $('[data-ajax-cart-trigger]');
        $addToCartBtn.find('.checkmark').addClass('checkmark-active');

        function addedToCart() {
          if (!isScreenSizeLarge()) {
            $el = $('.mobile-header [data-ajax-cart-trigger]');
            Shopify.theme.scrollToTop($el);
          } else {
            $el = $('[data-ajax-cart-trigger]');
          }

          $el.addClass('show-mini-cart');
          $addToCartBtn.find('span').removeClass('fadeInDown');
        }

        window.setTimeout(function () {
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
          $addToCartBtn.find('.text, .icon').removeClass('zoomOut').addClass('fadeInDown');
          $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);
        }, 1000);
        Shopify.theme.jsAjaxCart.showDrawer();
        Shopify.theme.jsAjaxCart.updateView();

        if (Shopify.theme.jsCart) {
          var _$$ajax;

          $.ajax((_$$ajax = {
            dataType: "json",
            async: false,
            cache: false
          }, _defineProperty(_$$ajax, "dataType", 'html'), _defineProperty(_$$ajax, "url", "/cart"), _defineProperty(_$$ajax, "success", function success(html) {
            var cartForm = $(html).find('.cart__form');
            $('.cart__form').replaceWith(cartForm);
          }), _$$ajax));
        }
      },
      error: function error(XMLHttpRequest) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        var cartWarning = "<p class=\"cart-warning__message animated bounceIn\">".concat(response.replace('All 1 ', 'All '), "</p>");
        $('.warning').remove();
        $addToCartForm.find('.cart-warning').html(cartWarning);
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');
        $addToCartBtn.find('.icon').removeClass('zoomOut').addClass('zoomIn');
        $addToCartBtn.find('.text').text(Shopify.translation.addToCart).removeClass('zoomOut').addClass('zoomIn');
      }
    });
  },
  addEventToButtons: function addEventToButtons () {
    $('[data-add-to-cart-btn]').map(function () {
      $(this).on('click', function () {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            quantity: 1,
            id: $(this).attr('data-cart-product-id'),
            form_type: 'product'
          },
          dataType: 'json',
          success: function (data) {
            Shopify.theme.jsAjaxCart.updateView();
          }
        });
      })
    })
  },
  updateView: function updateView() {
    Shopify.theme.asyncView.load('/cart', // template name
    'ajax' // view name (suffix)
    ).done(function (_ref3) {
      var html = _ref3.html,
          options = _ref3.options;

      if (options.item_count > 0) {
        var itemList = $(html.content).find('.ajax-cart__list');
        var cartDetails = $(html.content).find('.ajax-cart__details-wrapper');
        var promoMessages = $(html.content).find('.sidecart-promo-messages');
        $('.ajax-cart__list').replaceWith(itemList);
        $('.sidecart-promo-messages').replaceWith(promoMessages);
        if (typeof initSideCartPromoSlider !== 'undefined') {
            initSideCartPromoSlider();
        }
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);
        $('.index__cart-products-slider-container').removeClass('slider-hidden');
        $('#ajax-cart__content .bottomLine').removeClass('is-hidden');
        if (document.querySelector('.scroll-tabs__cart-num')) {
          if (options.item_count > 0) {
            document.querySelectorAll('.scroll-tabs__cart-num').forEach(function (el) {
              el.textContent = options.item_count;
            });
            document.querySelectorAll('.scroll-tabs__cart-count').forEach(function (el) {
              el.classList.remove('hidden');
            });
          } else {
            document.querySelectorAll('.scroll-tabs__cart-count').forEach(function (el) {
              el.classList.add('hidden');
            });
          }
        }
        Shopify.theme.jsAjaxCart.addEventToButtons();
        if($('#ajax-cart__progress_bar_products').length > 0) {
          var flkty = new Flickity($('#ajax-cart__progress_bar_products').get(0), {
            freeScroll: true,
            prevNextButtons: true,
            pageDots: false,
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            arrowShape: 'M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z'
          })
        }
        if ($('[data-bar-line]').length) {
          setTimeout(function () {
            const cartTotal = +$(html.content).find('[data-original-total-price]').attr('data-original-total-price').replace('$', '').replace(',', '');
            const cartShippingTotal = +$(html.content).find('[data-shipping-total-price]').attr('data-shipping-total-price').replace('$', '').replace(',', '');
            if (cartTotal < 3000) {
              const lineWidth = cartTotal / 3000 * 100;
              $('[data-bar-line]').each(function () {
                if (lineWidth > 10) {
                  $(this).attr('style', 'width: calc(' + lineWidth + '% - 9px)');
                } else if (lineWidth < 3 && lineWidth !== 0 ) {
                  $(this).attr('style', 'width: calc(' + lineWidth + '% + 3px)');
                } else {
                  $(this).attr('style', 'width:' + lineWidth + '%');
                }
              })
            } else {
              $('[data-bar-line]').each(function () {
                $(this).attr('style', 'width: calc(100% - 9px)');
              })
            }
            $('[data-shipping-success]').each(function () {
             $(this)[cartShippingTotal >= 2000 ? 'show' : 'hide']();
            })

          }, 600)
        }
      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
        $('.index__cart-products-slider-container').addClass('slider-hidden');
        $('#ajax-cart__content .bottomLine').addClass('is-hidden');
        if ($('[data-bar-line]').length) {
          $('[data-bar-line]').each(function () {
            $(this).attr('style', 'width: 0')
          })
        }
      }
      affirm.ui.refresh();

      if (options.bogo_remove) {
          localStorage.removeItem('bogo:' + options.bogo_remove);
      }

      if (options.bogo_variant && !localStorage.getItem('bogo:' + options.bogo_variant)) {
          localStorage.setItem('bogo:' + options.bogo_variant, 1);
          $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              cache: false,
              type: 'post',
              data: {id: options.bogo_variant, quantity: 1},
              success: function success(product) {
                  var $el = $('[data-ajax-cart-trigger]');
                  Shopify.theme.jsAjaxCart.showDrawer();
                  Shopify.theme.jsAjaxCart.updateView();

                  if (Shopify.theme.jsCart) {
                      var _$$ajax;

                      $.ajax((_$$ajax = {
                          dataType: "json",
                          async: false,
                          cache: false
                      }, _defineProperty(_$$ajax, "dataType", 'html'), _defineProperty(_$$ajax, "url", "/cart"), _defineProperty(_$$ajax, "success", function success(html) {
                          var cartForm = $(html).find('.cart__form');
                          $('.cart__form').replaceWith(cartForm);
                      }), _$$ajax));
                  }
              },
              error: function error(XMLHttpRequest) {
                  var response = eval('(' + XMLHttpRequest.responseText + ')');
                  response = response.description;
                  var cartWarning = "<p class=\"cart-warning__message animated bounceIn\">".concat(response.replace('All 1 ', 'All '), "</p>");
                  $('.warning').remove();
              }
          });
      }
    }).fail(function () {// some error handling
    });
    //Shopify.theme.jsAjaxCart.addEventToButtons();
  },
  unload: function unload($section) {
    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
};
